export default __webpack_public_path__ + "static/media/icon_housingSociety.d5682049.svg";